import type React from 'react'

interface IStarAiIconProps {
  className?: string
  width?: number
  height?: number
  color?: string
  gradient?: boolean
}

export const StarAiIcon: React.FC<IStarAiIconProps> = ({
  className,
  width = 24,
  height = 24,
  color = '#FFCB00',
  gradient = false,
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        {gradient && (
          <linearGradient
            id="star-ai-gradient"
            x1="0"
            y1="0"
            x2="24"
            y2="24"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0%" stopColor="#A0468A" />
            <stop offset="100%" stopColor="#6B4CD6" />
          </linearGradient>
        )}
      </defs>
      <path
        d="M17.5469 11.7898L13.65 10.3531L12.2102 6.45312C12.1001 6.15451 11.9011 5.89684 11.64 5.71484C11.3789 5.53284 11.0683 5.43526 10.75 5.43526C10.4318 5.43526 10.1212 5.53284 9.86008 5.71484C9.599 5.89684 9.39999 6.15451 9.28989 6.45312L7.85317 10.3531L3.95317 11.7898C3.65456 11.8999 3.39688 12.099 3.21488 12.36C3.03288 12.6211 2.9353 12.9317 2.9353 13.25C2.9353 13.5683 3.03288 13.8789 3.21488 14.14C3.39688 14.401 3.65456 14.6001 3.95317 14.7102L7.85004 16.1469L9.28989 20.0469C9.39999 20.3455 9.599 20.6032 9.86008 20.7852C10.1212 20.9672 10.4318 21.0647 10.75 21.0647C11.0683 21.0647 11.3789 20.9672 11.64 20.7852C11.9011 20.6032 12.1001 20.3455 12.2102 20.0469L13.6469 16.15L17.5469 14.7102C17.8455 14.6001 18.1032 14.401 18.2852 14.14C18.4672 13.8789 18.5648 13.5683 18.5648 13.25C18.5648 12.9317 18.4672 12.6211 18.2852 12.36C18.1032 12.099 17.8455 11.8999 17.5469 11.7898ZM12.5954 14.5367C12.4681 14.5836 12.3525 14.6576 12.2566 14.7535C12.1607 14.8494 12.0868 14.9649 12.0399 15.0922L10.75 18.5844L9.46332 15.0922C9.41643 14.9649 9.34247 14.8494 9.24658 14.7535C9.15068 14.6576 9.03511 14.5836 8.90786 14.5367L5.41567 13.25L8.90786 11.9633C9.03511 11.9164 9.15068 11.8424 9.24658 11.7465C9.34247 11.6506 9.41643 11.5351 9.46332 11.4078L10.75 7.91563L12.0368 11.4078C12.0837 11.5351 12.1576 11.6506 12.2535 11.7465C12.3494 11.8424 12.465 11.9164 12.5922 11.9633L16.0844 13.25L12.5954 14.5367ZM12.9375 5.125C12.9375 4.87636 13.0363 4.6379 13.2121 4.46209C13.3879 4.28627 13.6264 4.1875 13.875 4.1875H14.8125V3.25C14.8125 3.00136 14.9113 2.7629 15.0871 2.58709C15.2629 2.41127 15.5014 2.3125 15.75 2.3125C15.9987 2.3125 16.2371 2.41127 16.413 2.58709C16.5888 2.7629 16.6875 3.00136 16.6875 3.25V4.1875H17.625C17.8737 4.1875 18.1121 4.28627 18.288 4.46209C18.4638 4.6379 18.5625 4.87636 18.5625 5.125C18.5625 5.37364 18.4638 5.6121 18.288 5.78791C18.1121 5.96373 17.8737 6.0625 17.625 6.0625H16.6875V7C16.6875 7.24864 16.5888 7.4871 16.413 7.66291C16.2371 7.83873 15.9987 7.9375 15.75 7.9375C15.5014 7.9375 15.2629 7.83873 15.0871 7.66291C14.9113 7.4871 14.8125 7.24864 14.8125 7V6.0625H13.875C13.6264 6.0625 13.3879 5.96373 13.2121 5.78791C13.0363 5.6121 12.9375 5.37364 12.9375 5.125ZM21.6875 8.875C21.6875 9.12364 21.5888 9.3621 21.413 9.53791C21.2371 9.71373 20.9987 9.8125 20.75 9.8125H20.4375V10.125C20.4375 10.3736 20.3388 10.6121 20.163 10.7879C19.9871 10.9637 19.7487 11.0625 19.5 11.0625C19.2514 11.0625 19.0129 10.9637 18.8371 10.7879C18.6613 10.6121 18.5625 10.3736 18.5625 10.125V9.8125H18.25C18.0014 9.8125 17.7629 9.71373 17.5871 9.53791C17.4113 9.3621 17.3125 9.12364 17.3125 8.875C17.3125 8.62636 17.4113 8.3879 17.5871 8.21209C17.7629 8.03627 18.0014 7.9375 18.25 7.9375H18.5625V7.625C18.5625 7.37636 18.6613 7.1379 18.8371 6.96209C19.0129 6.78627 19.2514 6.6875 19.5 6.6875C19.7487 6.6875 19.9871 6.78627 20.163 6.96209C20.3388 7.1379 20.4375 7.37636 20.4375 7.625V7.9375H20.75C20.9987 7.9375 21.2371 8.03627 21.413 8.21209C21.5888 8.3879 21.6875 8.62636 21.6875 8.875Z"
        fill={gradient ? 'url(#star-ai-gradient)' : color}
      />
    </svg>
  )
}

export default StarAiIcon
